import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupCreateContentProps } from './msg-group-create-content';
import { MsgGroupCreateContent } from './msg-group-create-content';

export interface MsgGroupCreatePreviewProps extends MsgGroupCreateContentProps {}

export const MsgGroupCreatePreview = memo(function MsgGroupCreatePreview({
  message,
}: MsgGroupCreatePreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupCreateContent message={message} />
    </LastMessageSystem>
  );
});
